var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-jitsi-meet',{ref:"jitsiRef",attrs:{"domain":"localhost:8443","options":_vm.jitsiOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }